export default __webpack_public_path__ + "static/media/about-thumb-7-challenge.c00695a8.jpg";